import { useContext, useState, useEffect } from 'react'
import { login } from '../../context/authContext/apiCalls'
import { AuthContext } from '../../context/authContext/AuthContext'
import { Typography } from '@material-ui/core'

import './login.css'
const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { isFetching, message, error, dispatch } = useContext(AuthContext)
  const handleLogin = async () => {
    await login({ email, password }, dispatch)
  }
  useEffect(() => {
    if (message) {
      alert(message.message.data.message)
    }
  }, [message])
  return (
    <div className='login'>
      <div className='wrapperLogin'>
        <div className='wrapLogo'>
          <div className='userLogo'>
            <Typography
              className='logoMain'
              variant='h1'
              style={{ fontWeight: '500', fontSize: '30px' }}
            >
              NATIONAL LASER
            </Typography>
            <Typography
              className='logoSub'
              variant='h2'
              style={{ fontWeight: '100', fontSize: '20px' }}
            >
              INSTITUTE
            </Typography>
            <Typography
              className='slogan'
              variant='h6'
              style={{
                fontWeight: '100',
                fontSize: '15px',
                fontStyle: 'italic'
              }}
            >
              20 Years of Excellence!
            </Typography>
          </div>
        </div>
        <form className='loginForm'>
          <input
            type='text'
            autoComplete=''
            placeholder='Email'
            className='loginInput'
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type='password'
            autoComplete=''
            placeholder='Password'
            className='loginInput'
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type='button'
            className='loginButton'
            onClick={() => handleLogin()}
            disabled={isFetching}
          >
            Login
          </button>
          <a
            style={{ marginTop: '10px', color: '#000', textDecoration: 'none' }}
            className='forgotPasswordLink'
            href='/forgot-password'
          >
            Forgot Password
          </a>
          {error ? 'Wrong email or password! Please try again!' : null}
        </form>
      </div>
    </div>
  )
}

export default Login
